import { AddApprover } from './AddApprover';
import { useGetInvitedMembers } from '../../../../services/user.service';
import toast from 'react-hot-toast';
import { checkIsLockedAutomation } from '../../../../utils/lockAutomation';
import { Flex, Loader, Modal } from '@mantine/core';
import { useGetWorkflowById } from '../../../../services/workflow.services';

/**
 * @param {{
 *   id?: string;
 *   workflowId?: string;
 *   periodId?: any;
 *   onClose?: any;
 *   isOpen?: any;
 *   currentUser?: any;
 *   selectedPeriod?: any;
 * }} props
 */
export function ApproverDrawer({
  workflowId,
  periodId,
  onClose,
  isOpen,
  currentUser,
  selectedPeriod
}) {
  const isLocked = checkIsLockedAutomation(selectedPeriod, currentUser);
  const { data: workflow } = useGetWorkflowById({
    id: workflowId,
    queryParams: {
      enabled: !!workflowId
    }
  });

  const isFormPF = workflow?.report_type === 'Form PF';

  // One unified screen — access config + approval status + add/remove, all in the same list.
  const { isFetching } = useGetInvitedMembers({
    queryKey: 'invitedMembers',
    params: {
      period_id: periodId,
      workflow_id: workflowId
    },
    queryOptions: {
      enabled: !!periodId && isOpen,
      cacheTime: 0,
      staleTime: 0,
      onError: () => {
        toast.error('Server error');
      }
    }
  });

  if (isFetching) {
    return (
      <Modal
        title="Reviewers and approvals"
        size={window.innerWidth < 1000 ? '94%' : '880px'}
        centered
        opened={isOpen}
        onClose={onClose}
      >
        <Flex justify="center" align="center" style={{ height: 'min(72vh, 460px)' }}>
          <Loader size="lg" />
        </Flex>
      </Modal>
    );
  }

  return (
    <AddApprover
      isOpen={isOpen}
      onClose={onClose}
      workflowId={workflowId}
      periodId={periodId}
      isFormPF={isFormPF}
      isLocked={isLocked}
    />
  );
}
